module.exports = __webpack_public_path__ + "assets/french-flag.3159fb28.svg";